<template>
    <div class="formGroup">
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
        <validation-observer v-else-if="forms" ref="Form">
            <b-form class="formBox"> 
                <template v-for="f in forms" >
                    <template v-if="f.type =='multiInput' && (f.connectField ? connectFieldControl(f) : true)">
                        <div class="multiInput" :key="f.name">
                            <div class="header">  
                                <span class="title" > {{f.title}} </span>
                                <b-button @click="addNewRecord(f)" size="sm" variant="success"> 
                                    <b-icon icon="plus" />
                                </b-button>
                            </div>
                            <div class="inputs">
                                <div class="fieldset" v-for="(m, index) in formData[f.name]" :key="index">
                                <b-form-group v-for="i in f.inputs" :key='i.name' class="inputGrp" :label-for="m.name">

                                    <MaskedInput v-if="i.type == 'masked'"  mask="\+\ 11 (111) 111 1111" v-model="formData[f.name][index][i.name]" :placeholder="i.title" class="form-control" />
                                    <Multiselect
                                        v-else-if="i.type == 'select'" 
                                        :id="i.name" 
                                        v-model="formData[f.name][index][i.data[0]]" 
                                        :show-labels="false" 
                                        :options="i.options && getData(i.name, i.options)"
                                        :label="i.options && i.options.label"
                                        :track-by="i.options && i.options.track" >
                                            <template slot="singleLabel" slot-scope="{ option }">
                                                <strong>{{ option[i.options.label] }} </strong> 
                                            </template>
                                    </Multiselect>
                                    <b-form-radio-group 
                                        v-else-if="i.type == 'radio'"
                                        style="flex-direction: row; flex-wrap: wrap;"
                                        v-model="formData[f.name][index][i.name]"
                                        :options="i.options && getData(i.name, i.options)"
                                        inline
                                    />
                                    <b-form-input v-else v-model="formData[f.name][index][i.name]" :placeholder="i.title" />
                                </b-form-group>
                                <b-form-group class="inputGrp" >
                                    <b-button @click="removeTheRecord(f, index)" size="sm" variant="danger"> 
                                        <b-icon icon="x" />
                                    </b-button>
                                </b-form-group>
                            </div>
                        </div>
                        </div>
                    </template>
                    <validation-provider 
                        v-else-if="f.connectField ? connectFieldControl(f) : true"
                        :key="f.name"
                        :name="f.title" 
                        :rules="getRules(f)"
                        v-slot="validationContext">
                        <b-form-group 
                            class="inputGrp" 
                            :label="f.type !== 'camera' && f.type !== 'grid' && f.title" 
                            :label-for="f.name"
                        >
                            <div 
                            class="elements" 
                            :style="{
                                width: (f.type == 'editor' || f.type=='tags' || f.type=='camera' || f.type =='grid') && '100%',
                               'min-width': (f.type == 'editor' || f.type=='tags' || f.type=='camera' || f.type =='grid') && '500px'
                            }">
                                <b-form-input 
                                    v-if="f.type == 'text' || f.type == 'password'" 
                                    :type="f.type"
                                    :id="f.name" 
                                    v-model="formData[f.name]" 
                                    :state="getValidationState(validationContext)"
                                    :disabled="f.checkBox ? !formData[f.checkBox.name] : f.disabled ? true : false"
                                    @change="f.name == 'password' && checkPwd()"
                                    :placeholder="f.placeHolder && f.placeHolder"
                                />
                                <Multiselect
                                    v-else-if="f.type == 'select'" 
                                    :id="f.name" 
                                    v-model="formData[f.name]" 
                                    :show-labels="false" 
                                    :options="f.options && getData(f.name, f.options)"
                                    :label="f.options && f.options.label"
                                    @input="e => f.nextField && setNextField(e, f)"
                                    :state="getValidationState(validationContext)"
                                    :track-by="f.options && f.options.track" 
                                    :custom-label="opt => f.options.labels ? customLabel(opt, f) : opt[f.options.label]"
                                    @search-change=" s => f.options.search && searchSelect(s, f)"
                                    :multiple="f.options.multiple"
                                    >
                                        <template slot="singleLabel" slot-scope="{ option }">
                                            <strong v-if="f.options.labels">{{ f.options.labels.map(l => option[l] ).join(' ') }} </strong> 
                                            <strong v-else>{{ option[f.options.label] }} </strong> 
                                        </template>
                                </Multiselect>
                                <Datetime 
                                    v-else-if="f.type == 'date' || f.type == 'time' || f.type == 'datetime'"
                                    v-model="formData[f.name]" 
                                    :type="f.type"
                                    :state="getValidationState(validationContext)"
                                    @input="e => f.nextField && setNextField(e, f)"
                                />
                                <b-form-radio-group 
                                    v-else-if="f.type == 'radio'"
                                    v-model="formData[f.name]"
                                    :options="f.options && getData(f.name, f.options)"
                                    style="flex-direction: row; flex-wrap: wrap;"
                                    inline
                                />
                                <vue-editor 
                                    v-else-if="f.type == 'editor'"
                                    v-model="formData[f.name]" 
                                    :state="getValidationState(validationContext)"
                                />
                                <MaskedInput
                                    v-else-if="f.type == 'masked'"
                                    mask="\+\ 11 (111) 111 1111"
                                    v-model="formData[f.name]"
                                    :state="getValidationState(validationContext)"
                                    class="form-control"
                                />
                                <b-form-textarea 
                                    v-else-if="f.type == 'textarea'"
                                    :id="f.name"
                                    rows="3"
                                    v-model="formData[f.name]"
                                    :state="getValidationState(validationContext)"
                                ></b-form-textarea>
                                <b-form-file
                                    v-else-if="f.type == 'file'"
                                    :multiple="f.multiple"
                                    v-model="formData[f.name]"
                                    file_id="file"
                                    :placeholder="f.placeHolder"
                                    :state="getValidationState(validationContext)"
                                ></b-form-file>
                                <div  v-else-if="f.type == 'camera'">
                                    <figure v-if="formData[f.name] " class="figure">
                                        <b-button variant="danger" @click="() => formData[f.name] = null" > Yeniden Çek </b-button>
                                        <img :src="formData[f.name] " class="img-responsive" />
                                    </figure>
                                    <div v-else>
                                        <b-button variant="primary" @click="captureImg(f)" > Resim Çek </b-button>
                                        <WebCam
                                            ref="camera"
                                            :selectFirstDevice="true"
                                            screenshotFormat="image/png"
                                        />
                                    </div>
                                </div>
                               
                                <div
                                    v-else-if="f.type == 'tags'">
                                    <b-form-tags 
                                        :placeholder="f.placeHolder"
                                        :add-button-text="f.addBtnText"
                                        v-model="formData[f.name]"
                                        :separator="f.seperator"
                                        :state='getValidationState(validationContext, f)'
                                    ></b-form-tags>
                                        <b-form-invalid-feedback v-if="formData[f.name].length !== (parseInt(formData[f.beforeField])|| 0)" id="live-feedback" style="display: block; width: 100%;">
                                            Girdiğiniz ürün sayısı, girmeniz gerekenden farklıdır. 
                                            <span v-if="((parseInt(formData[f.beforeField]) || 0) - formData[f.name].length) > 0"> {{(parseInt(formData[f.beforeField]) || 0) - formData[f.name].length }} adet ürün eksik </span>
                                            <span v-else> {{formData[f.name].length - (parseInt(formData[f.beforeField]) || 0)}} adet ürün fazla </span>

                                        </b-form-invalid-feedback>
                                </div>
                                <div v-else-if="f.type == 'grid'" >
                                    
                                    <div  v-if="LDAPData.length > 0">
                                        <div class="gridTitle">
                                            <div>
                                                <h5> {{ f.title }}</h5>
                                            </div>
                                            <div style="display:flex">
                                                <div class="selected" v-if="formData[f.name]" @click="removeGridSelect(f)"> 
                                                    {{formData[f.name][0][f.data[0]]}} 
                                                    <b-icon icon="x" variant="danger" font-scale="1.5"/>
                                                </div>
                                                <b-form-input
                                                    id="filter-input"
                                                    v-model="filter"
                                                    type="search"
                                                    placeholder="Arama Yap"
                                                />
                                            </div>
                                           
                                        </div>
                                        <b-table
                                            v-if="selected.length>0"
                                            :items="selected"
                                            :fields="getGridTitle(selected[0])"
                                            :select-mode="'single'"
                                            responsive="sm"
                                            ref="selectableTable"
                                            selectable
                                            :filter="filter"> 
                                            <template #cell(selected)="data">
                                                <b-icon icon="x" variant="danger" font-scale="1.5"  @click="removeGridSelect(f)"/>
                                            </template>
                                        </b-table>
                                        <b-table
                                            v-else
                                            :items="LDAPData"
                                            :fields="getGridTitle(LDAPData[0])"
                                            :select-mode="'single'"
                                            responsive="sm"
                                            ref="selectableTable"
                                            selectable
                                            :filter="filter"
                                            @row-selected="(items) => onRowSelected(f, items)" 
                                        />
                                    </div>
                                    <p v-else-if="formData[f.beforeField]"> Seçtiğiniz filtreye ait kayıt bulunamamıştır. </p>
                                   
                                </div>

                                <b-form-checkbox v-if="f.checkBox" v-model="formData[f.checkBox.name]"/>
                                <b-button v-if="f.additionalButton" @click="additionalButtonEvent(f)" :size="f.additionalButton.size" :variant="f.additionalButton.variant" :title="f.additionalButton.title"> 
                                    <b-icon :icon="f.additionalButton.icon" />
                                </b-button>
                            </div>
                            <b-form-invalid-feedback id="live-feedback" style="display: block">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>

                        </b-form-group>
                    </validation-provider>
                </template>
            </b-form>
            <CustomField v-if="customField && customField.length>0" :data="customField" />
        </validation-observer>
        <p v-else> Form Bulunamadı...</p>
        <CustomerModal v-if="modalType == 'Customer'" :open="modalOpen" :modalEvent="modalEvent" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
        <UserModal v-if="modalType == 'User'" :open="modalOpen" :modalEvent="modalEvent" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
        <DefinationModal v-else :open="modalOpen" :modalEvent="modalEvent" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>
               
<script>
    import Multiselect from 'vue-multiselect'
    import { Datetime } from 'vue-datetime';
    import {setFormData, sendRequestList} from '@/assets/js/custom.js'
    import { VueEditor } from "vue2-editor";
    import moment from 'moment';
    import MaskedInput from 'vue-masked-input'
    import DefinationModal from "@/pages/General/Defination/modals/"
    import CustomerModal from "@/pages/General/Customer/modals/"
    import UserModal from "@/pages/General/Users/modals/"
    import CustomField from '@/components/CustomField'
    import { WebCam } from "vue-web-cam";
    import _ from 'lodash'

    export default {
        name: "Forms",
        props:{
            forms: Array,
            data: Object,
            loading: Boolean,
            save: Boolean,
            sendRequest: Function,
            saveState: Function,
            customField: Array
        },
        components:{
            Multiselect, Datetime, VueEditor, MaskedInput,DefinationModal, CustomerModal, CustomField, WebCam, UserModal
        },
        watch:{
             save: function(data){
                if(data){
                    this.$refs.Form.validate().then( async (success) => {
                        success && this.sendRequest();
                        this.saveState(false)
                    })
                }
             },
             data: function(data){
                this.getFormData()
             }
        },
        data:function(){
            return {
                formData: {},
                modalOpen: false,
                modalProps: {},
                modalName:'',
                currentForm: '',
                modalType: '',
                filter: '',
                selected: []
            }
        },
        mounted: async function(){
            await this.getFormData()
               
        },
        computed:{
            accountType: function(){
                return this.$store.getters.getAccountTypes
            },
            job: function(){
                return this.$store.getters.getJobs
            },
            address: function(){
                return this.$store.getters.getCustomerAddresses.length > 0 ? this.$store.getters.getCustomerAddresses : this.$store.getters.getAccountAddress.address
            },
            customeraddresses: function(){
                return this.$store.getters.getCustomerAddresses
            },
            brand: function(){
                return this.$store.getters.getBrands
            },
            signalProtocol: function(){
                return this.$store.getters.getProtocols
            },
            model: function(){
                return this.$store.getters.getModels
            },
            devicetype(){
                return this.$store.getters.getDeviceTypes
            },
            system_module(){
                return this.$store.getters.getSystemModules
            },
            account_user(){
                return this.$store.getters.getAccountUsers
            },
            signal_group(){
                return this.$store.getters.getSignalGroups
            },
            task(){
                return this.$store.getters.getTasks
            },
            zoneType(){
                return this.$store.getters.getZoneTypes
            },
            company(){
                return this.$store.getters.getCompanies
            },
            country(){
                return this.$store.getters.getCountries
            },
            city(){
                return this.$store.getters.getCities
            },
            district(){
                return this.$store.getters.getTowns
            },
            company_id(){
                return this.$store.getters.getCompanies
            },
            subscription(){
                return this.$store.getters.getSubscriptions
            },
            customer() {
                return this.$store.getters.customerList
            },
            stock() {
                return this.$store.getters.stockList
            },
            movement_type() {
                return this.$store.getters.movementTypes
            },
            stock_pieces() {
                return this.$store.getters.pieces
            },
            fault_movements_type() {
                return this.$store.getters.faultStatuses
            },
            users() {
                return this.$store.getters.getUsers
            },
            fault_result() {
                return this.$store.getters.faultSupportResults
            },
            warehouse() {
                return this.$store.getters.getWarehouses
            },
            to_warehouse() {
                return this.$store.getters.getWarehouses
            },
            authGrp(){
                return this.$store.getters.getAuth
            },
            userType(){
                return this.$store.getters.getUserTypes
            },
            user(){
                return this.$store.getters.getUsers
            },
            ADAttribute(){
                return this.$store.getters.getADAttributes
            },
            ADFilter(){
                return this.$store.getters.getADFilters
            },
            LDAPData(){
                if(this.formData['ADFilter'])
                    return this.$store.getters.getLDAPData
                else return []
            },
            companyType(){
                return this.$store.getters.getCompanyTypes
            }

        },
        methods:{
            getValidationState({ dirty, validated, valid = null },f) {
                if(f && f.type == 'tags')
                    return dirty ? (this.formData[f.beforeField] == (this.formData[f.name] ? this.formData[f.name].length : 0)) : null;

                return dirty || validated ? valid : null;
            },
            getGridTitle(data){
                return Object.keys(data)
            },
            removeGridSelect(f){
                this.filter = '';
                this.formData[f.name] = null
                this.selected = []
            },
            onRowSelected(f, items){
                if(this.selected.length>0){
                    this.removeGridSelect(f)
                }else if(items.length>0){
                    let tmpItems = {selected: true}
                    tmpItems = _.merge(tmpItems,items[0])
                    this.formData[f.name] = [tmpItems]
                    this.selected = [tmpItems]
                }
                
               
            },
            async getFormData(){
                this.formData = await setFormData(this.forms, this.data)
                await sendRequestList(this.forms,this)
            },

            connectFieldControl(f){
                if(f.connectFieldKey){
                    return this.formData[f.connectField] ? f.connectFieldValue.includes(this.formData[f.connectField][f.connectFieldKey]) : false
                }else if(f.connectFieldValue){
                    return f.connectFieldValue.includes(this.formData[f.connectField])
                }else if(f.connectField){
                    return this.formData[f.connectField] ? Object.keys(this.formData[f.connectField]).length > 0 : false
                }
            },

            captureImg(f){
                this.formData[f.name] = this.$refs.camera[0].capture()
            },

            getRules(f){
                if(f.checkBox )
                    if(!this.formData[f.checkBox.name])
                        return {}
                return f.rules
                
            },
            customLabel(item, f){
                return f.options.labels.map(l => item[l] ).join(' ') 
            },
            searchSelect(s, f){
                let params = {}
                params[f.options.label] = s
                this.$store.dispatch(f.name+'_list', params)

            },
            checkPwd(){
                let againIndex = this.forms.findIndex(e => e.name == 'passwordAgain')
                if(againIndex > -1 ){
                    this.forms[againIndex].rules.is = this.formData['password']
                    this.$refs.Form.validate();
                }
            },
            getData(data, options){
                if(options){
                    return options.data.length > 0 ? options.data : this[data] ? this[data] : []
                }else 
                    return this[data] ? this[data] : []
            },
            setNextField(data, field){
                switch(field.type){
                    case 'date':
                        this.formData[field.nextField] = moment(data).add(1, 'years').format('YYYY-MM-DD')
                        break;
                    case 'select':
                        let params = []
                        let beforeField = field.beforeField
                        while(beforeField !== undefined){
                            let bF = this.forms.find(e => e.name == beforeField)
                            params.push(this.formData[beforeField][bF.options.track])
                            beforeField = bF.beforeField
                        }
                        if(field.nextField)
                            params.push(this.formData[field.name][field.options.track])
                        this.$store.dispatch(field.nextField+'_list',params) 
                        break;
                }
            },
            modalEvent(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }else{
                    sendRequestList(this.forms,this)
                }
            },
            async additionalButtonEvent(data){
                switch(data.additionalButton.type){
                    case 'newAccount':
                        let cid = this.$route.params.cid ? this.$route.params.cid : this.$route.params.id
                        await this.$store.dispatch('getNewAccountNumber',cid) 
                        this.formData[data.name] = this.$store.getters.getNewAccountNo
                        console.log(this.$store.getters.getNewAccountNo, this.formData)
                        break;
                    default:
                        this.modalType = data.additionalButton.type
                        this.currentForm = data.name
                        if(data.beforeField){
                            let track = this.forms.find(e => e.name == data.beforeField).options.track
                            this.modalProps.parent_id = this.formData[data.beforeField][track]
                        }
                        console.log(data, this.modalProps)
                        this.modalEvent(true,'add', this.modalProps)
                        break;
                }
            },
            removeTheRecord(f, i){
                this.formData[f.name].splice(i,1)
            },
            addNewRecord(f){
                let tmpData = {}
                f.inputs.map(i => {
                    tmpData[i.name]= ''
                })
                this.formData[f.name].push(tmpData)
            }
        },
    }
</script>

<style lang="css" scoped>
    @import "./styles/add.min.css";

</style>



// WEBPACK FOOTER //
// src/components/Form.vue